export default {
  openAddWidget: {
    label: 'Open Add Widget panel',
    keys: ['shift+q'],
    desc: 'Opens the list of widgets to add panel',
    default: false
  },
  openAddSection: {
    label: 'Open Add Section panel',
    keys: ['shift+w'],
    desc: 'Opens the list of sections to add panel',
    default: false
  },
  openAssetsImages: {
    label: 'Open Image Assets',
    keys: ['shift+a'],
    desc: 'Opens image asstes panel',
    default: false
  },
  openAssetsShapes: {
    label: 'Open Shape Assets',
    keys: ['shift+s'],
    desc: 'Opens shape assets panel',
    default: false
  },
  openFontAssets: {
    label: 'Open Font Assets',
    keys: ['shift+d'],
    desc: 'Opens font assets panel',
    default: false
  },
  openSettingsProject: {
    label: 'Open Project Settings',
    keys: ['shift+z'],
    desc: 'Opens project settings',
    default: false
  },
  openSettingsStyles: {
    label: 'Open Project Styles',
    keys: ['shift+x'],
    desc: 'Opens project style styles settings',
    default: false
  },
  openSettingsMenues: {
    label: 'Open Menu Editor',
    keys: ['shift+c'],
    desc: 'Opens menu editor menues settings',
    default: false
  }
};
